<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
        <div class="ts-app-shell--header">
            <h5 class="dashboard-title">Skills Passport</h5>
            <!-- <div class="ts-app-shell--header_actions flexed">
                <button class="ts-btn ts-btn-small" @click="back">Back</button>
            </div> -->
        </div>
    </div>
    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <el-row :gutter="20">
          <el-col :span="24">
          </el-col>
        </el-row>
        <el-row :gutter="20">     
          <el-col :xl="5" :lg="5" :md="24" :sm="24" :xs="24" style="text-align:center">
            <el-card :body-style="{ padding: '0px' }" shadow="hover" >
              <div class="card-body" @click="gotoSearchSkills">
                <h6 class="card-font">Search <br/> Skills</h6>
                  <div class="dash-card">
                    <i class="fas fa-binoculars"></i>
                  </div>                        
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button class="ts-btn-small card-button">Create</el-button>
                    </span>
                  </div>
              </div>
            </el-card>
          </el-col>

          <el-col :xl="15" :lg="15" :md="24" :sm="24" :xs="24">
            <br>
            <h6 class="card-font">Manage Your Skills Passport</h6> <br>
            <p>
              Explore career options and gauge the level of knowledge and your skill 
              set compared to your desired job’s criteria and identify skills gaps 
              that you need to improve on to help you land your dream job. <br/> 
              (We also suggest related training and courses here.)
            </p>
          </el-col> 
        </el-row>

        <el-row :gutter="20">     
          <el-col :xl="5" :lg="5" :md="24" :sm="24" :xs="24" style="text-align:center">
            <el-card :body-style="{ padding: '0px' }" shadow="hover" >
              <div class="card-body" @click="gotoSkillsSummary">
                <h6 class="card-font">Skills Passport <br/> Summary</h6>
                  <div class="dash-card">
                    <i class="fas fa-list-alt"></i>
                  </div>                        
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button class="ts-btn-small card-button">Manage</el-button>
                    </span>
                  </div>
              </div>
            </el-card>
          </el-col>

          <el-col :xl="15" :lg="15" :md="24" :sm="24" :xs="24">
            <br>
            <h6 class="card-font">Manage Your Skills Passport Summary</h6> <br>
            <p>
              Manage the list of career plans you selected for your growth. 
            </p>
          </el-col> 
        </el-row>
        </div>
    </div>
  </div>
</template>

<script>

export default {
    components: {

    },
    created() {

    },
    computed: {
      applicantUserInfo() {
        return this.$store.state.account.applicant_user_info
      }
    },
    data() {
        return {
            
        }
    },
    methods: {
        back(){
          this.$router.back();
        },
        gotoSearchSkills(){
          if(this.applicantUserInfo.skillProfileCompleted)
          {
            if (this.applicantUserInfo.apprenticeId) {
              this.$router.push({ name: 'ApprenticeSearchCareer'});
            } else if (this.applicantUserInfo.jobSeekerId) {
              this.$router.push({ name: 'JobSeekerSearchCareer'});
            }          
          }
          else
          {
            this.$confirm(
              `You must complete your Skills Profile first!`,
              "Warning",
              {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "warning",
                dangerouslyUseHTMLString: true,
                center: true
              }
            ).then(() => {});
          }
          
        },
        gotoSkillsSummary(){
          if(this.applicantUserInfo.skillProfileCompleted)
          {
            if (this.applicantUserInfo.apprenticeId) {
              this.$router.push({ name: 'ApprenticeSkillsPassportList'});
            } else if (this.applicantUserInfo.jobSeekerId) {
              this.$router.push({ name: 'JobSeekerSkillsPassportList'});
            }           
          }
          else
          {
            this.$confirm(
              `You must complete your Skills Profile first!`,
              "Warning",
              {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "warning",
                dangerouslyUseHTMLString: true,
                center: true
              }
            ).then(() => {});
          }       
        },
    }
}
</script>
<style lang="scss" scoped>

</style>